import React, {useState, useMemo, useRef, useEffect} from 'react';

interface CountDownProps {
  /** 倒计时，单位：秒 */
  remain?: number;
  /** 倒计时结束后重新计时的时间，单位：秒 */
  resetTime: number;
  serverTime?: number;
  currentTime?: number;
  reverse?: boolean;
}

const CountDown: React.FC<CountDownProps> = ({
  resetTime = 0,
  remain = 0,
  currentTime = 0,
  serverTime = 0,
  reverse = false,
}) => {
  const remainRef = useRef<number | undefined>(undefined);
  const [remainTime, setRemainTime] = useState(0);
  const remainValue = useMemo(() => {
    const hour = Math.floor(remainTime / 3600);
    const minutes = Math.floor(remainTime / 60) % 60;
    const seconds = remainTime % 60;
    return {
      h: (hour + '').padStart(2, '0'),
      m: (minutes + '').padStart(2, '0'),
      s: (seconds + '').padStart(2, '0'),
    };
  }, [remainTime]);

  useEffect(() => {
    const left = (currentTime - serverTime) / 1000;
    if (left) {
      if (remain) {
        if (remainRef.current === undefined) {
          remainRef.current = remain;
        }
        remainRef.current = remainRef.current - 1;
        if (remainRef.current <= 0) {
          remainRef.current = resetTime;
        }
        setRemainTime(remainRef.current);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime, serverTime]);
  return (
    <div
      className={`flex item-center text-9 font-black text-center leading-4 ${
        reverse ? 'text-white' : ''
      }`}>
      <div
        className={`w-4 h-4 ${
          reverse ? 'bg-white text-main' : 'bg-black text-white'
        } rounded-sm`}>
        {remainValue.h}
      </div>
      &nbsp;:&nbsp;
      <div
        className={`w-4 h-4 ${
          reverse ? 'bg-white text-main' : 'bg-black text-white'
        } rounded-sm`}>
        {remainValue.m}
      </div>
      &nbsp;:&nbsp;
      <div
        className={`w-4 h-4 ${
          reverse ? 'bg-white text-main' : 'bg-black text-white'
        } rounded-sm`}>
        {remainValue.s}
      </div>
    </div>
  );
};

export default CountDown;
